<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>New Raw Pin</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-form ref="form">
        <v-layout class="px-4 mb-3">
          <v-flex>
            <v-layout>
              <v-flex>
                <div class="subtitle-2 mb-1">
                  What's the Content of the Pin?
                </div>
                <v-textarea
                  rows="3"
                  v-model="content"
                  :rules="rules.textarea"
                  dense
                  outlined
                  placeholder="Pin Content"
                  counter
                  maxlength="200"
                ></v-textarea>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <div class="subtitle-2 mb-1">Title</div>
                <v-text-field
                  rows="3"
                  hide-details
                  v-model="title"
                  dense
                  outlined
                  placeholder="Pin Title"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout class="mt-3">
              <v-flex class="mr-1" xs6>
                <div class="subtitle-2 mb-1">Schedule At</div>
                <v-text-field
                  readonly
                  v-model="scheduledAtDateString"
                  hide-details
                  dense
                  outlined
                  placeholder="Scheduled Date"
                  @click="openScheduleDateDialog"
                ></v-text-field>
              </v-flex>
              <v-flex class="ml-1" xs6>
                <div class="subtitle-2 mb-1">Expires In</div>
                <v-select
                  dense
                  hide-details
                  placeholder="Expires In"
                  outlined
                  v-model="expiryRange"
                  :items="expiryRanges"
                  @change="onExpiryDateRangeSelected"
                  no-data-text="Please select a Schedule Time first"
                >
                </v-select>
              </v-flex>
            </v-layout>
            <v-layout class="mt-3" v-if="expiresAtDateString">
              <v-flex xs6>
                <div class="subtitle-2 mb-1">Expires At</div>
                <v-text-field
                  v-model="expiresAtDateString"
                  readonly
                  hide-details
                  dense
                  outlined
                  placeholder="Expire Date"
                  @click="openExpiryDateDialog"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout class="mt-3">
              <div class="subtitle-1 font-weight-medium">Pin Options</div>
            </v-layout>
            <v-layout class="mt-3">
              <v-flex>
                <div class="subtitle-2 mb-1">Region</div>
                <v-select
                  outlined
                  dense
                  return-object
                  :rules="[(v) => !!v || 'Item is required']"
                  required
                  hide-details
                  :items="regions"
                  v-model="region"
                  item-text="name"
                  placeholder="Region"
                >
                </v-select>
              </v-flex>
            </v-layout>
            <!-- <v-layout class="mt-3">
              <v-flex>
                <div class="subtitle-2 mb-1">Entity</div>
                <v-autocomplete
                  :loading="loading"
                  v-model="entity"
                  :items="reviewedEntities"
                  cache-items
                  :search-input.sync="searchTerm"
                  hide-details
                  return-object
                  item-text="title"
                  item-value="title"
                  placeholder="Select Entity"
                  no-data-text="Type a name of an entity to search"
                  outlined
                  chips
                  dense
                  @change="entitySelected"
                ></v-autocomplete>
              </v-flex>
            </v-layout>

            <v-layout v-if="entity">
             
              <v-btn
                v-if="entity.instagram"
                icon
                target="_blank"
                :href="entity.instagram"
              >
                <v-icon>mdi-instagram </v-icon>
              </v-btn>
              <v-btn
                v-if="entity.facebook"
                icon
                target="_blank"
                :href="entity.facebook"
              >
                <v-icon>mdi-facebook </v-icon>
              </v-btn>
              <v-btn
                v-if="entity.website"
                icon
                target="_blank"
                :href="entity.website"
              >
                <v-icon>mdi-globe </v-icon>
              </v-btn>
            </v-layout>
            <v-layout>
              <v-checkbox
                v-model="hasCustomLocation"
                label="Use a custom location"
              ></v-checkbox>
            </v-layout> -->
            <v-layout class="mt-3">
              <v-flex class="mr-1">
                <div class="subtitle-2 mb-1">Latitude</div>
                <v-text-field
                  outlined
                  dense
                  hide-details
                  v-model="latitude"
                  placeholder="Latitude"
                >
                </v-text-field>
              </v-flex>
              <v-flex class="ml-1">
                <div class="subtitle-2 mb-1">Longitude</div>
                <v-text-field
                  outlined
                  dense
                  hide-details
                  v-model="longitude"
                  placeholder="Longitude"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            <!-- <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Entity</div>
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="reviewedEntities"
                v-model="entity"
                item-text="title"
                placeholder="Region"
              >
              </v-select>
            </v-flex>
          </v-layout> -->
            <v-layout class="mt-3">
              <v-flex>
                <div class="subtitle-2 mb-1">Pin Type</div>
                <v-autocomplete
                  outlined
                  dense
                  hide-details
                  return-object
                  :items="pinTypes"
                  v-model="pinType"
                  item-text="name"
                  placeholder="Pin Type"
                  chips
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout class="mt-3">
              <v-flex xs6 class="mr-1">
                <div class="subtitle-2 mb-1">Link Name</div>
                <v-text-field
                  v-model="linkName"
                  hide-details
                  dense
                  outlined
                  placeholder="Link Name"
                ></v-text-field>
              </v-flex>

              <v-flex xs6 class="ml-1">
                <div class="subtitle-2 mb-1">Link URL</div>
                <v-text-field
                  v-model="linkUrl"
                  hide-details
                  dense
                  outlined
                  placeholder="Ex: http://..."
                ></v-text-field>
              </v-flex>
            </v-layout>

            <gallery-image-select-section
              ref="galleryImageSelectSectionRef"
              @imageSelected="galleryImageSelected"
            />
          </v-flex>
        </v-layout>
      </v-form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Schedule
        </v-btn>
      </v-card-actions>
    </v-card>

    <time-and-date-select-dialog
      @onDateSelected="onExpiryDateSelected"
      ref="ExpiryTimeAndDateDialogRef"
    />
    <time-and-date-select-dialog
      @onDateSelected="onScheduleDateSelected"
      ref="ScheduleTimeAndDateDialogRef"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import firebase from 'firebase';
import _ from 'lodash';
import { auth } from '@/plugins/firebase';
import moment from 'moment';
import TimeAndDateSelectDialog from './TimeAndDateSelectDialog.vue';
import GalleryImageSelectSection from '@/modules/Assets/components/GalleryImageSelectSection';

export default {
  props: {
    selectedRegion: {
      type: Object,
      default: function() {
        return {};
      },
    },
    collection: {
      type: String,
      default: function() {
        return {};
      },
    },
  },
  components: {
    TimeAndDateSelectDialog,
    GalleryImageSelectSection,
  },
  data() {
    return {
      dialog: false,
      rules: {
        textarea: [(v) => v.length <= 150 || 'Max 150 characters'],
        select: [(v) => !!v || 'Item is required'],
      },
      hasCustomLocation: false,
      expiryRange: '',

      searchTerm: '',
      loading: false,
      scheduleDateDialog: false,
      expiryDateDialog: false,
      scheduledAtDateField: '',
      expiresAtDateField: '',
      scheduledAt: '',
      expiresAt: '',
      region: {},
      title: '',
      // entity: {},
      createdBy: '',
      content: '',
      bgColor: '',
      iconColor: '',
      iconName: '',
      iconType: '',
      isMarker: true,
      location: {},
      firebaseUrl: '',
      imageThumbnail: '',
      imageUrl: '',
      pinType: '',
      linkUrl: '',
      linkName: '',
      latitude: 0,
      longitude: 0,

      selectedFromGallery: false,
    };
  },
  computed: {
    ...mapState('$_home', ['regions']),
    ...mapState('$_entity', ['reviewedEntities']),
    ...mapGetters({
      pinTypes: '$_home/pinTypes',
    }),
    expiryRanges() {
      return this.scheduledAtDateField
        ? ['6 Hours', '12 Hours', '18 Hours', '24 Hours']
        : [];
    },
    scheduledAtDateString() {
      if (this.scheduledAtDateField) {
        return this.iMoment(this.scheduledAtDateField);
      } else {
        return this.scheduledAt;
      }
    },
    expiresAtDateString() {
      if (this.expiresAtDateField) {
        return this.iMoment(this.expiresAtDateField);
      } else {
        return this.expiresAt;
      }
    },

    changeFields() {
      return {
        scheduledAt: this.iMoment(this.scheduledAtDateField),
        state: 'scheduled',

        type: 'pin',
        region: this.region,
        expiryRange: this.expiryRange,
        createdBy: {
          id: auth.currentUser.uid,
          email: auth.currentUser.email,
          name: auth.currentUser.displayName,
        },

        pinType: this.pinType,
        data: {
          expiresAt: this.iMoment(this.expiresAtDateString),
          content: this.content,
          createdBy: auth.currentUser.uid,
          title: this.title,
          graphics: {
            entity: this.pinType.name,
            logoUrl: this.pinType.logo ? this.pinType.logo : '',
            displayPriority: this.pinType.displayPriority
              ? this.pinType.displayPriority
              : Number(0),
            icon: {
              bgColor: this.pinType.backgroundColor,
              color: this.pinType.fontColor,
              name: this.pinType.fontName,
              type: this.pinType.fontFamily,
            },
          },
          image: this.imageUrl
            ? {
                firebaseUrl: this.firebaseUrl,
                thumbnail: this.imageThumbnail,
                url: this.imageUrl,
              }
            : null,
          link: this.linkUrl
            ? {
                url: this.linkUrl,
                name: this.linkName,
              }
            : null,
          isMarker: this.isMarker,
          location: new firebase.firestore.GeoPoint(
            parseFloat(this.latitude),
            parseFloat(this.longitude),
          ),

          score: Number(0),
          totalComments: Number(0),
          type: this.pinType.name,
          views: Number(0),
          showInFeed: true,
        },
      };
    },
  },
  watch: {
    searchTerm: _.debounce(function(e) {
      e && this.searchEntities(e);
    }, 300),
  },
  mounted() {
    this.getRegions({ collection: 'regions', mutation: 'updateRegions' });
    this.getPinTypes({ collection: 'pinTypes', mutation: 'updatePinTypes' });
    // this.getEntityTypes({
    //   collection: "entityTypes",
    //   mutation: "updateEntityTypes",
    // });
    // this.getEntities({
    //   collection: "entities",
    //   condition: {
    //     leftVal: "state",
    //     operator: "==",
    //     rightVal: "reviewed",
    //   },
    //   mutation: "updateReviewedEntities",
    // });
  },
  methods: {
    ...mapActions({
      createNewPin: '$_content/createNewContent',
      uploadImage: '$_content/uploadImage',
      getRegions: '$_home/getContent',
      getEntityTypes: '$_home/getContent',
      getEntities: '$_entity/getContent',
      getPins: '$_content/getContent',
      getPinTypes: '$_home/getContent',
      getPinsByRegion: '$_content/getContentByRegion',
      searchEntitiesAction: '$_entity/searchContent',
    }),
    validate() {
      this.$refs.form.validate();
    },
    // entitySelected(entity) {
    //   console.log("Selected Entity: ", entity);
    //   if (entity) {
    //     this.pinType = entity.default ? entity.default.pinType : {};
    //     this.linkUrl = entity.default ? entity.default.linkUrl : "";
    //     this.linkName = entity.default ? entity.default.linkName : "";
    //     this.latitude = entity.location.latitude;
    //     this.longitude = entity.location.longitude;
    //   } else {
    //     this.latitude = 0;
    //     this.longitude = 0;
    //   }
    // },
    openImageGallery() {
      this.$refs.imageGalleryRef.toggleDialog();
    },
    searchEntities(searchTerm) {
      this.loading = true;
      console.log('searching Tags: ', searchTerm);

      this.searchEntitiesAction({
        collection: 'entities',
        mutation: 'updateReviewedEntities',
        searchTerm: searchTerm,
      }).then(() => {
        this.loading = false;
      });
    },
    iMoment(date) {
      if (date) {
        // console.log(date);
        return moment(date).toDate();
      }
      return new Date();
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    openExpiryDateDialog() {
      this.$refs.ExpiryTimeAndDateDialogRef.toggleDialog(
        this.expiresAtDateField,
      );
    },
    onExpiryDateRangeSelected(timeRange) {
      console.log('Expiry Selected time range: ', timeRange);
      switch (timeRange) {
        case '6 Hours':
          this.expiresAtDateField = moment(this.scheduledAtDateField).add(
            6,
            'hours',
          );
          break;
        case '12 Hours':
          this.expiresAtDateField = moment(this.scheduledAtDateField).add(
            12,
            'hours',
          );
          break;
        case '18 Hours':
          this.expiresAtDateField = moment(this.scheduledAtDateField).add(
            18,
            'hours',
          );
          break;
        case '24 Hours':
          this.expiresAtDateField = moment(this.scheduledAtDateField).add(
            24,
            'hours',
          );
          break;
        default:
          this.expiresAtDateField = this.scheduledAtDateField;
      }
    },
    onExpiryDateSelected(dateTime) {
      this.expiresAtDateField = dateTime;
      console.log(this.expiresAtDateField);
    },
    openScheduleDateDialog() {
      this.$refs.ScheduleTimeAndDateDialogRef.toggleDialog(
        this.scheduledAtDateField,
      );
    },
    onScheduleDateSelected(dateTime) {
      // console.log("Scheduled Selected Date and Time: ", dateTime);
      this.scheduledAtDateField = dateTime;
    },
    galleryImageSelected(image) {
      this.selectedFromGallery = image ? true : false;
      this.firebaseUrl = image.firebaseUrl ? image.firebaseUrl : '';
      this.imageThumbnail = image.thumbnail;
      this.imageUrl = image.url;
    },
    cancel() {
      this.scheduledAtDateField = '';
      this.expiresAtDateField = '';
      this.scheduledAt = '';

      this.state = '';
      this.region = {};
      //this.entity = {};
      this.createdBy = '';
      this.content = '';
      this.bgColor = '';
      this.iconColor = '';
      this.iconName = '';
      this.iconType = '';
      this.isMarker = true;
      this.location = {};
      this.imageThumbnail = '';
      this.imageUrl = '';
      this.pinType = {};
      this.expiryRange = '';
      this.linkName = '';
      this.linkUrl = '';
      this.title = '';
      if (this.selectedFromGallery == true) {
        this.$refs.galleryImageSelectSectionRef.galleryImageDeselect();
      }
      this.selectedFromGallery = false;

      this.dialog = false;
    },
    save() {
      console.log(this.entity);
      console.log(this.changeFields);
      if (!this.scheduledAtDateString) {
        alert('Yo yo, Slow down dude, add a Scheduled At time');
        return;
      }
      this.createNewPin({
        details: this.changeFields,
        collection: this.collection,
        type: 'Pin',
      }).then(() => {
        this.cancel();
        this.getPinsByRegion({
          type: 'pin',
          collection: this.collection,
          mutation: 'updatePins',
          region: this.selectedRegion,
        });
      });
    },
  },
};
</script>

<style></style>
